import { module } from 'angular';

import { default as unitOutgoingCallServiceName, UnitOutgoingCallDeprecatedService } from './unit-outgoing-call-deprecated.service';

export default module('contact.agent.core.phone.outcall', [])
  .run([unitOutgoingCallServiceName, () => {}])
  .service(unitOutgoingCallServiceName, UnitOutgoingCallDeprecatedService).name;
